"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Display Fields
var uniqueId = 'uniqueId';
var image = 'image';
var file = 'file';
var richText = 'richText';
var block = 'block';

// Data Fields
var text = 'text';
var textarea = 'textarea';
var number = 'number';
var dropdown = 'dropdown';
var multiSelect = 'multiSelect';
var date = 'date';
var signature = 'signature';
var list = 'list';
var user = 'user';
var task = 'task';
var table = 'table';
var inputGroup = 'inputGroup';
var chart = 'chart';
var collection = 'collection';
var types = {
  uniqueId: uniqueId,
  image: image,
  file: file,
  block: block,
  richText: richText,
  text: text,
  textarea: textarea,
  number: number,
  date: date,
  signature: signature,
  list: list,
  user: user,
  task: task,
  table: table,
  inputGroup: inputGroup,
  chart: chart,
  multiSelect: multiSelect,
  dropdown: dropdown,
  collection: collection
};
types.all = Object.keys(types);
types.titles = {
  uniqueId: 'Auto Number',
  image: 'Image',
  file: 'File',
  block: 'Display Text',
  richText: 'Rich Text',
  text: 'Short Text',
  textarea: 'Long Text',
  number: 'Number',
  date: 'Date',
  signature: 'Signature',
  user: 'User',
  table: 'Table Field',
  inputGroup: 'Field Group',
  chart: 'Performance Chart',
  multiSelect: 'Checkbox',
  dropdown: 'Dropdown',
  collection: 'Collection'
};
var _default = exports["default"] = types;